import { Table } from 'antd';
import { AppButton } from 'shared/UI/UIKit/Button';
import { AppFlex } from 'shared/UI/UIKit/Flex';
import type { TeacherWorkload } from 'shared/api';
import { useTeacherWorkloadTable } from '../model';
import { ReplaceClassesModal } from './components';
import styles from './styles.module.scss';

type TeacherWorkloadTableProps = {
  teacherWorkload: TeacherWorkload;
  isQueryRefetching?: boolean;
};

export const TeacherWorkloadTable = ({
  teacherWorkload,
  isQueryRefetching = false,
}: TeacherWorkloadTableProps) => {
  const {
    state: {
      tableData,
      tableColumns,
      tableLoading,
      canSave,
      isSaving,
      tableDisabled,
      educationClasses,
      hasRowSelection,
      rowSelection,
      replaceClassesModalOpen,
    },
    methods: { onSave, openReplaceClassesModal, closeReplaceClassesModal, applyReplaceClasses },
  } = useTeacherWorkloadTable(teacherWorkload, isQueryRefetching);
  return (
    <AppFlex direction="column" unit="12">
      <AppFlex direction="row" justifyContent="flex-end" alignItems="center" unit="8">
        {hasRowSelection ? (
          <AppButton
            type="outline"
            htmlType="button"
            disabled={tableDisabled}
            onClick={openReplaceClassesModal}
          >
            Заменить классы
          </AppButton>
        ) : null}
        <AppButton
          type="primary"
          htmlType="button"
          disabled={!canSave}
          loading={isSaving}
          onClick={onSave}
        >
          Сохранить
        </AppButton>
      </AppFlex>
      <Table
        rowKey="key"
        loading={tableLoading}
        pagination={false}
        dataSource={tableData}
        columns={tableColumns}
        rowSelection={rowSelection}
        scroll={{ x: 'max-content' }}
        className={styles.teacherWorkloadTable}
      />
      <ReplaceClassesModal
        visible={replaceClassesModalOpen}
        onCancel={closeReplaceClassesModal}
        onApply={applyReplaceClasses}
        educationClasses={educationClasses}
        tableDisabled={tableDisabled}
      />
    </AppFlex>
  );
};
